<!-- Simply Amazing Deals -->
<section class="w-full px-4 md:px-8 lg:px-15 dark:bg-slate-800" [ngClass]="view.site?.id === 11 ? 'pt-8 md:pt-12 mt-6 md:mt-8' : 'mt-15'">
    <div class="flex flex-col items-center justify-center" [ngClass]="view.site?.id === 72 ? 'pt-6 md:pt-8' : ''">
        @if(view.site?.id === 98 || view.site?.id === 58) {
        <!-- Site 98 / 58: show Specials + Unbeatable Offers -->
        <div class="w-full flex justify-center items-center mb-10">
            <div class="w-full flex flex-row px-2 justify-center items-center">
                <div class="flex flex-col">
                    <div class="w-full flex justify-center items-center">
                        <div class="w-full flex flex-row md:pl-10 lg:pl-10 justify-between items-center">
                            <app-heading_section-type01
                                [options]="{ heading:'Specials', title:'Unbeatable Offers', image:'', description:'', swooshAlign: {'margin':''}, headingStyle: {'display':'block','visibility':'visible','opacity':1,'color':'#92400e'} }"></app-heading_section-type01>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        @if(view.site?.id !== 79 && view.site?.id !== 98 && view.site?.id !== 58) {
        <div class="w-full flex justify-center items-center mb-10">
            <div class="w-full flex flex-row px-2 justify-center items-center">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                <div class="flex flex-col">
                    <div class="w-full flex justify-center items-center">
                        <div class="w-full flex flex-row md:pl-10 lg:pl-10 justify-between items-center">
                            @switch (view.site.profile.heading.position) {
                            @case (1) {
                            <app-heading_section-type01
                                [options]="{heading:'Specials',title:'Simply Amazing Deals',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                            }
                            @case (2) {
                            <app-heading_section-type01
                                [options]="{heading:'Specials',title:'Simply Amazing Deals',image:'assets/xltravel/swoosh-01.svg', description:''}"></app-heading_section-type01>
                            }
                            <!-- @case (3) {
                                <app-heading_section-type01 [options]="{heading:'Leisure Travel',title:'',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                                } -->
                            @case (4) {
                            <app-heading_section-type01
                                [options]="{ heading:'Specials',title:'Unbeatable Offers',image:'', description:'' }"></app-heading_section-type01>
                            }
                            }
                        </div>
                    </div>
                </div>
                } @else {
                <!-- Fallback when profile.heading is missing (e.g. landing page): show Specials + Unbeatable Offers with visible heading -->
                <div class="flex flex-col">
                    <div class="w-full flex justify-center items-center">
                        <div class="w-full flex flex-row md:pl-10 lg:pl-10 justify-between items-center">
                            <app-heading_section-type01
                                [options]="{ heading:'Specials', title:'Unbeatable Offers', image:'', description:'', swooshAlign: {'margin':''}, headingStyle: {'display':'block','visibility':'visible','opacity':1,'color':'#92400e'} }"></app-heading_section-type01>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
        }
        @if(view.site?.id === 79) {
        <div class="flex flex-col justify-center max-w-3xl">
            <div class="flex justify-center">
                <img src="/assets/images/sections/ST HOLIDAY PACKAGES.png" class="w-100 pb-5"
                    alt="holiday packages header image">
            </div>
            @if(!isLandingPage) {
            <div>
                <p class="pb-10 text-center" [innerHTML]="this.view.page?.content.rawContent"></p>
            </div>
            }
        </div>
        }
        @if (view.loadingDeals) {
        <div class="flex items-center justify-center py-16 min-h-[200px]">
            <mat-progress-spinner mode="indeterminate" diameter="48" color="primary"></mat-progress-spinner>
            <span class="ml-4 text-gray-500">Loading packages...</span>
        </div>
        } @else {
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-8">
            @for(deal of view.deals; track deal) {
            <fuse-card
                class=" flex flex-col w-full w-{380} mx-auto  overflow-hidden shadow-md hover:shadow-lg dark:border-0 dark:border-gray-500 dark:bg-gray-600">
                <div class="relative">
                    <img class="w-full h-60" [src]="deal.imageUrls[0]" alt="Destination Image">
                    <div class="absolute inset-0 bg-black opacity-30"></div>
                    <div
                        class="absolute top-0 right-0 text-white px-8 py-6 text-3xl tracking-wider font-primary text-shadow">
                        {{deal.destination}}</div>
                </div>
                <div class="flex flex-col justify-center h-45 p-5 mb-2">
                    @if(deal.supplier && deal.supplier.grading > 0 && deal.supplier.grading <= 1) { <div
                        class="flex mb-2">
                        <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                </div>
                }
                @if(deal.supplier && deal.supplier.grading > 1 && deal.supplier.grading <= 2) { <div class="flex mb-2">
                    <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                    <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
        </div>
        }
        @if(deal.supplier && deal.supplier.grading > 2 && deal.supplier.grading <= 3) { <div class="flex mb-2">
            <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
    </div>
    }
    @if(deal.supplier && deal.supplier.grading > 3 && deal.supplier.grading <= 4) { <div class="flex mb-2">
        <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
        <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
        <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
        <mat-icon class="icon-size-5 text-accent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
        </div>
        }
        @if(deal.supplier && deal.supplier.grading > 4 && deal.supplier.grading <= 5) { <div class="flex mb-2">
            <mat-icon class="icon-size-5 text-acent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            <mat-icon class="icon-size-5 text-acent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            <mat-icon class="icon-size-5 text-acent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            <mat-icon class="icon-size-5 text-acent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            <mat-icon class="icon-size-5 text-acent-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
            </div>
            }

            <p class="text-xl lg:text-2xl font-primary font-semibold mb-2 min-h-14">{{deal.name}}</p>
            <div class="flex flex-wrap items-center gap-3 py-2">

                @if(deal.tags) {
                <div class="flex flex-wrap gap-2">
                    @for (tag of deal.tags.split(','); track tag) {
                    <span class="bg-accent-500 text-white text-sm rounded-full py-1 px-3 flex items-center">
                        {{ tag.trim() }}
                    </span>
                    }
                </div>
                }

                @if(deal.basis) {
                <div class="flex-shrink-0">
                    <span
                        class="bg-primary-500 text-white text-sm rounded-full py-1 px-3 flex items-center whitespace-nowrap">
                        {{ deal.basis }}
                    </span>
                </div>
                }

            </div>

            <div class="flex items-center justify-between">
                <div class="flex flex-col space-y-2">
                    <p class="text-gray-400">{{deal.nights}} {{deal.nights === 1 ? 'Night' : 'Nights'}}</p>
                    <p class="text-gray-400">From <span
                            class="text-primary-500 text-2xl font-semibold">{{deal.priceBundleTotal | currency:displayCurrencyCode:'symbol-narrow'}}</span><sup class="mx-1">pps</sup></p>
                </div>

                <a [routerLink]="['/package', deal.id, deal.slug ? deal.slug : slugify(deal.name)]" type="button" class="inline-block rounded-md ring-1 ring-accent-500 
                    text-sm sm:text-base font-bold text-center
                    px-2 py-1 sm:py-2
                    transition duration-300 
                    hover:bg-accent-500 hover:text-accent-100">
                    View More
                </a>

                <!-- <a [routerLink]="['/package', deal.id, deal.slug]" type="button"
                    class=" ring-accent-500 text-md lg:text-lg text-center font-bold py-1 lg:py-2 px-2 md:px-3 transition cursor-pointer transition-duration: 500ms hover:bg-accent-500 hover:text-accent-100">View
                    More</a> -->
            </div>
            </div>
            </fuse-card>
            }
        </div>
        }
    </div>
    <!-- <div
                class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center ng-star-inserted mt-8">
                <div
                    class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                    <a class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-800"
                        [routerLink]="'/packages'">View all Packages</a>
                </div>
            </div> -->
</section>
<!-- <app-slide-banner-type01></app-slide-banner-type01> -->
